import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=355d03bc"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('355d03bc')) {
      api.createRecord('355d03bc', component.options)
    } else {
      api.reload('355d03bc', component.options)
    }
    module.hot.accept("./Payment.vue?vue&type=template&id=355d03bc", function () {
      api.rerender('355d03bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/Payment.vue"
export default component.exports